import * as React from "react";
import {Typography as BaseTypography, type TypographyProps} from "@atg-ui/design-system";
import {useTheme, useMediaQuery, type Theme} from "@atg-ui/design-system/theme";
import type {ThemeKeyUnions} from "@atg-ui/design-system/style";

export interface Props extends TypographyProps {
    color?: ThemeKeyUnions<Theme["color"]["text"]>;
    textDecorationColor?: ThemeKeyUnions<Theme["color"]["text"]>;
    testId?: string;
    /**
     * Flag to enable masking of the text for external tools.
     */
    masked?: boolean;
    sm?: TypographyProps["variant"];
    md?: TypographyProps["variant"];
    lg?: TypographyProps["variant"];
}

export const Typography = React.forwardRef<HTMLParagraphElement, Props>(
    (
        {
            variant = "body.md",
            color = "default",
            textDecorationColor = "default",
            testId,
            masked = false,
            children,
            sm,
            md,
            lg,
            ...rest
        },
        ref,
    ) => {
        const theme = useTheme();

        const smScreen = useMediaQuery(theme.breakpoints.up("sm")) ?? false;
        const mdScreen = useMediaQuery(theme.breakpoints.up("md")) ?? false;
        const lgScreen = useMediaQuery(theme.breakpoints.up("lg")) ?? false;

        let resposiveVariant = variant;
        if (smScreen && sm) {
            resposiveVariant = sm;
        } else if (mdScreen && md) {
            resposiveVariant = md;
        } else if (lgScreen && lg) {
            resposiveVariant = lg;
        }

        return (
            <BaseTypography
                ref={ref}
                variant={resposiveVariant}
                color={`text.${color}`}
                textDecorationColor={`text.${textDecorationColor}`}
                data-di-mask={masked || undefined}
                data-hj-masked={masked || undefined}
                data-test-id={testId}
                {...rest}
            >
                {children}
            </BaseTypography>
        );
    },
);
